import React from 'react';
import { ATMField, ATMForm, ATMGrid, ATMInput } from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { SensitiveCommunitiesFormSchema } from 'src/models/sensitive-communities.model';

type IProp = {
  formRef: React.RefObject<HTMLFormElement>;
  defaultValues?: any;
  handleSubmit: (data) => void;
  handleEnable: (value) => void;
};

const SensitiveCommunitiesForm: React.FC<IProp> = ({
  formRef,
  defaultValues = {},
  handleSubmit,
  handleEnable,
}) => {
  return (
    <div className="form-container">
      <ATMForm
        ref={formRef}
        onSubmit={handleSubmit}
        mode="onChange"
        defaultValues={defaultValues}
        validationSchema={SensitiveCommunitiesFormSchema}
      >
        {({ control, errors, formState }) => {
          handleEnable(formState.isDirty);

          return (
            <ATMGrid>
              <ATMGrid.Row columns="2">
                <ATMGrid.Column>
                  <ATMField
                    label={Lang.LBL_SENSITIVE_COMMUNITIES}
                    name="sensitiveCommunity"
                    control={control}
                    as={ATMInput}
                    placeholder={Lang.LBL_ENTER}
                    clearable
                    required
                    error={errors.sensitiveCommunity}
                  />
                </ATMGrid.Column>
                <ATMGrid.Column>
                  <ATMField
                    label={Lang.LBL_SENSITIVE_COMMUNITY_PAM_LEAD}
                    name="sensitiveCommunityPamLead"
                    control={control}
                    as={ATMInput}
                    placeholder={Lang.LBL_ENTER}
                    clearable
                    required
                    error={errors.sensitiveCommunityPamLead}
                  />
                  <ATMField
                    as={ATMInput}
                    type="hidden"
                    name="sensitiveCommunityId"
                    control={control}
                    error={errors.sensitiveCommunityId}
                  />
                </ATMGrid.Column>
              </ATMGrid.Row>
            </ATMGrid>
          );
        }}
      </ATMForm>
    </div>
  );
};

export default SensitiveCommunitiesForm;
